import React from 'react';
import {
  Container,
  Typography,
  Paper,
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon
} from '@mui/material';
import {
  CheckCircle,
  LocalShipping,
  Assignment,
  Security,
  MonetizationOn,
  Support,
  Inventory
} from '@mui/icons-material';

const Policy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom 
          align="center"
          sx={{ 
            fontWeight: 'bold',
            color: 'primary.main',
            mb: 4
          }}
        >
          سياسة المتجر وشروط الخدمة
        </Typography>

        {/* Inspection Policy */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ color: 'secondary.main', mb: 2 }}>
            <Assignment sx={{ verticalAlign: 'middle', mr: 1 }} />
            سياسة الفحص والاستلام
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="يجب فحص المنتج بوجود المندوب"
                secondary="من حق العميل فحص المنتج والتأكد من سلامته قبل استلامه من المندوب"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="في حالة وجود عيب أو تلف"
                secondary="يحق للعميل رفض استلام المنتج وإرجاعه فوراً بدون أي رسوم إضافية"
              />
            </ListItem>
          </List>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Delivery Policy */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ color: 'secondary.main', mb: 2 }}>
            <LocalShipping sx={{ verticalAlign: 'middle', mr: 1 }} />
            سياسة التوصيل
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="يتم إيصال الطلبات خلال 48 ساعة إلى 72 ساعة"
                secondary="من تاريخ تأكيد الطلب ودفع المبلغ المطلوب"
              />
            </ListItem>
            
           
          </List>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Payment Policy */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ color: 'secondary.main', mb: 2 }}>
            <MonetizationOn sx={{ verticalAlign: 'middle', mr: 1 }} />
            سياسة الدفع
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="الدفع عند الاستلام"
                secondary="يمكن الدفع نقداً عند استلام المنتج من المندوب"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="التحويل المصرفي"
                secondary="يمكن الدفع مسبقاً عبر التحويل المصرفي أو المحافظ الإلكترونية"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="عدم قبول الشيكات"
                secondary="لا نقبل الدفع بالشيكات أو الدفع بالتقسيط"
              />
            </ListItem>
          </List>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Return Policy */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ color: 'secondary.main', mb: 2 }}>
            <Inventory sx={{ verticalAlign: 'middle', mr: 1 }} />
            سياسة الإرجاع والاستبدال
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="يتم ارجاع الطلب فقط في حال تم فحصه بحضور المندوب"
                secondary="لايمكن ارجاع المنتج بعد مغادرة المندوب للموقع"
              />
            </ListItem>
           
            
          </List>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Warranty Policy */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ color: 'secondary.main', mb: 2 }}>
            <Security sx={{ verticalAlign: 'middle', mr: 1 }} />
            سياسة الضمان
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="ضمان المنتجات الفحص بحضور المندوب فقط"
                secondary="يسقط حق الزبون في الضمان في حال عدم فحص المنتج بحضور المندوب"
              />
            </ListItem>
            
            
          </List>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Customer Service */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ color: 'secondary.main', mb: 2 }}>
            <Support sx={{ verticalAlign: 'middle', mr: 1 }} />
            خدمة العملاء
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="أوقات العمل"
                secondary="من السبت إلى الخميس، من الساعة 9 صباحاً حتى 8 مساءً"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="طرق التواصل"
                secondary="عبر الهاتف، الواتساب، أو البريد الإلكتروني"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="الرد على الاستفسارات"
                secondary="نلتزم بالرد على جميع الاستفسارات خلال 24 ساعة"
              />
            </ListItem>
          </List>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Privacy */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ color: 'secondary.main', mb: 2 }}>
            <Security sx={{ verticalAlign: 'middle', mr: 1 }} />
            سياسة تخزين البيانات والخصوصية
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            جمع وتخزين البيانات الشخصية
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="البيانات المجمعة"
                secondary="نجمع ونخزن: الاسم، رقم الهاتف، العنوان، البريد الإلكتروني، تفاصيل الطلبات، وسجل المعاملات لتسهيل عملية الشراء وتقديم الخدمة"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="مدة الاحتفاظ بالبيانات"
                secondary="نحتفظ بالبيانات الشخصية لمدة أقصاها 7 سنوات من آخر معاملة أو حسب متطلبات القانون العراقي، ويمكن حذفها عند طلب العميل"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="تشفير البيانات"
                secondary="جميع البيانات الحساسة مشفرة باستخدام معايير SSL/TLS وتقنيات التشفير المتقدمة (AES-256) لضمان الأمان التام"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="خوادم آمنة"
                secondary="نستخدم خوادم محمية ومراقبة على مدار الساعة مع نسخ احتياطية منتظمة وحماية من الاختراق والوصول غير المصرح به"
              />
            </ListItem>
          </List>

          <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            استخدام البيانات (متوافق مع معايير Meta)
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="الغرض من الاستخدام"
                secondary="نستخدم البيانات حصرياً لمعالجة الطلبات، التواصل مع العملاء، تحسين الخدمة، وإرسال تحديثات مهمة عبر WhatsApp Business API"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="WhatsApp Business API"
                secondary="نستخدم WhatsApp Business API فقط لإرسال: رموز التحقق، تأكيد الطلبات، تحديثات الشحن، والدعم الفني وفقاً لشروط Meta"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="عدم المشاركة"
                secondary="لا نبيع أو نشارك أو ننقل البيانات الشخصية لأي طرف ثالث إلا بموافقة صريحة أو لمتطلبات قانونية"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="حقوق العميل"
                secondary="يحق للعميل طلب الاطلاع على بياناته، تعديلها، أو حذفها نهائياً في أي وقت عبر التواصل معنا"
              />
            </ListItem>
          </List>

          <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            الامتثال للمعايير الدولية
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="معايير Meta/Facebook"
                secondary="نلتزم بجميع شروط وأحكام Meta Business وWhatsApp Business API بما يشمل حماية البيانات والاستخدام المسؤول"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="GDPR (لوائح حماية البيانات الأوروبية)"
                secondary="نطبق مبادئ GDPR لحماية بيانات العملاء الأوروبيين: الشفافية، تقليل البيانات، دقة البيانات، وحق النسيان"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="القانون العراقي"
                secondary="نلتزم بقانون حماية البيانات الشخصية العراقي وجميع التشريعات المحلية ذات الصلة"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="مراجعة دورية"
                secondary="نراجع سياسات الأمان والخصوصية بشكل دوري ونحدثها لضمان أعلى معايير الحماية والامتثال"
              />
            </ListItem>
          </List>

          <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            الإجراءات الأمنية المتقدمة
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="المراقبة الأمنية"
                secondary="نراقب النظام على مدار الساعة للكشف عن أي أنشطة مشبوهة أو محاولات اختراق وتطبيق الإجراءات الوقائية فوراً"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="التحديثات الأمنية"
                secondary="نطبق التحديثات الأمنية بانتظام ونستخدم أحدث بروتوكولات الحماية وجدران الحماية المتقدمة"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="النسخ الاحتياطية"
                secondary="نأخذ نسخاً احتياطية مشفرة من البيانات يومياً ونخزنها في مواقع آمنة متعددة لضمان استمرارية الخدمة"
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="التدريب على الأمان"
                secondary="جميع الموظفين مدربون على أفضل ممارسات الأمان السيبراني وحماية البيانات والتعامل مع المعلومات الحساسة"
              />
            </ListItem>
          </List>

          <Box sx={{ mt: 3, p: 2, backgroundColor: 'info.light', borderRadius: 1 }}>
            <Typography variant="body2" color="info.contrastText">
              <strong>ملاحظة مهمة:</strong> هذه السياسة تتوافق مع معايير Meta Business وWhatsApp Business API. 
              لأي استفسارات حول استخدام بياناتك أو لطلب نسخة من معلوماتك الشخصية، 
              يرجى التواصل معنا عبر البريد الإلكتروني أو الهاتف.
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mt: 4, p: 3, backgroundColor: 'grey.100', borderRadius: 2 }}>
          <Typography variant="body2" align="center" color="text.secondary">
            آخر تحديث: سبتمبر 2025 | متجر الصادق - جميع الحقوق محفوظة
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mt: 1 }}>
            للاستفسارات حول هذه السياسة أو لطلب نسخة من بياناتك، يرجى التواصل معنا عبر الواتساب أو الهاتف
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mt: 1, fontWeight: 'bold' }}>
            🔒 متوافق مع معايير Meta Business وGDPR
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default Policy;
